import {
  getCurrentCompletedQuestions,
  getCurrentCompletedQuizTotal,
} from './getCurrentCompletedQuiz'

export const getCompletedPercentage = (
  questions,
  currentQuestionIndex,
  currentChoiceIndex,
): any => {
  if (!questions.length) return 0

  const totalAmount = getCurrentCompletedQuizTotal(questions)

  const totalCompletedParts = getCurrentCompletedQuestions(
    questions,
    currentQuestionIndex,
    currentChoiceIndex,
  )

  const completedPercentage = Math.round((totalCompletedParts / totalAmount) * 100)
  return completedPercentage > 100 ? 100 : completedPercentage
}
